import { Button, List, ListItem, ListItemText } from '@mui/material';
import React, { useContext } from 'react';
import { SwatchesPicker } from 'react-color';
import { CustomizationContext } from './contexts/customizationContext';
import './styles/Customizer.css';

export function ColorCustomizer({ setDialogType }) {
  // stateful variables
  const { customizations, setCustomizations } = useContext(CustomizationContext);

  const changeBackgroundColor = (color, event) => {
    setCustomizations({
      ...customizations,
      background: { ...customizations.background, color: color.hex, type: 'color' },
    });
  };
  const changeMainColor = (color, event) => {
    setCustomizations({ ...customizations, colors: { ...customizations.colors, main: color.hex } });
  };
  const changeSecondaryColor = (color, event) => {
    setCustomizations({ ...customizations, colors: { ...customizations.colors, secondary: color.hex } });
  };

  return (
    <>
      <List style={{ padding: '30px' }}>
        <ListItem>
          <List>
            <ListItemText>Background Color</ListItemText>
            <SwatchesPicker onChangeComplete={changeBackgroundColor} />
          </List>
        </ListItem>
        <ListItem>
          <List>
            <ListItemText>Main Color</ListItemText>
            <SwatchesPicker onChangeComplete={changeMainColor} />
          </List>
        </ListItem>
        <ListItem>
          <List>
            <ListItemText>Second Color</ListItemText>
            <SwatchesPicker onChangeComplete={changeSecondaryColor} />
          </List>
        </ListItem>
        <ListItem alignItems="center">
          <Button
            onClick={() => {
              setDialogType('');
            }}
            sx={{ color: customizations.colors.secondary }}
          >
            Close Customizer
          </Button>
        </ListItem>
      </List>
    </>
  );
}
